<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5>Паузы по активности</h5>
      </div>
      <div class="card-body">
        <div class="flex flex_gap">
          <div class="form-group">
            <label for="">Период (c 11.12)</label>
            <div>
              <DateRangePicker
                ref="range"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="">Мин.пауза (минут)</label>
            <input type="number" v-model="minPause" class="form-control">
          </div>
          <div class="form-group">
            <label for="">Группы</label>
            <CustomMultiSelect ref="selectedGroup" :records="getGroupsByUser()"/>
          </div>
          <div class="form-group flex-grow-1">
            <label for="">Пользователи</label>
            <CustomMultiSelect ref="selectedUsers" :records="usersForSelect ?? users"/>
          </div>
          <div class="align-self-end action_btns">
            <LoadingButton
              title="Сбросить"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords(true)"
              className="btn btn-outline-info"
            />
            <LoadingButton
              title="Показать"
              :loading="loading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => getRecords()"
              className="btn btn-outline-success"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="loading || records">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <div class="flex flex_gap_10">
          <button v-for="o in filter.options" @click="changeFilter(o)" type="button"
                  :class="{'btn btn-outline-primary': true, 'active':filter.current.type === o.type}">{{ o.alias }}
          </button>
        </div>

        <div class="table_div_block">
          <table class="table table-sm table-hover mt-1 table-bordered">
            <thead class="fs-12">
            <tr>
              <th class="def_width"></th>
              <th v-for="u in selectedUsers" v-if="hasRecords(u.id)" class="text-wrap">{{ u.id }} {{ u.name }}</th>
            </tr>
            <tr>
              <th class="def_width"></th>
              <th v-for="u in selectedUsers" v-if="hasRecords(u.id)">
                <div class="flex flex_gap_10 flex-wrap">
                  <span @click="selectGroup(g.id)" class="badge badge-primary pointer"
                        v-for="g in getGroupsByUser(u.id)">{{ g.title }} {{ g.projects }}</span>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="fixed-side">минуты/смены</td>
              <td v-for="u in selectedUsers" v-if="hasRecords(u.id)">
                {{ totalShifts[u.id]?.total_duration ?? 0 }} ({{ totalShifts[u.id]?.total_shifts ?? 0 }})
              </td>
            </tr>
            <tr>
              <td class="fixed-side">паузы/%</td>
              <td v-for="u in selectedUsers" v-if="hasRecords(u.id)">
                {{ totalDatByUserId(u.id) }} ({{ totalDatByUserId(u.id, false) }}%)
              </td>
            </tr>

            <tr v-for="(r, date) in records">
              <td class="fixed-side">{{ printDate(date, 'DD.MM.YYYY') }}</td>
              <template v-for="u in selectedUsers" v-if="hasRecords(u.id)">
                <td class="">
                  <div v-if="(r[u.id] ?? []).filter((d) => d.status).length" class="flex flex_gap_10">
                    <v-popover
                      class=""
                      trigger="click"
                      popoverClass="activity_list_popover"
                      popoverInnerClass="popover_content"
                      :auto-hide="true">
                      <div class="pointer">
                        <span class="badge badge-info">{{ r[u.id].filter((d) => d.status).length }}</span>
                      </div>
                      <template slot="popover">
                        <p v-for="d in r[u.id]" v-if="d.status">
                          {{ printDate(d.date_start, 'HH:mm', 3) }} - {{ printDate(d.date_end, 'HH:mm', 3) }} ({{
                            printDiff(d)
                          }})
                        </p>
                      </template>
                    </v-popover>
                    <span>({{ getTotalDuration(r[u.id]) }})</span>
                  </div>
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import moment from "moment";

export default {
  components: {DateRangePicker, LoadingButton, CustomMultiSelect},
  props: ['usersForSelect'],
  data() {
    return {
      loading: false,
      users: [],
      minPause: 10,
      records: null,
      filter: {
        options: [{
          type: 1,
          alias: 'по группам'
        },
          {
            type: 2,
            alias: 'max паузы(мин)'
          },
          {
            type: 3,
            alias: 'max паузы(%)'
          }],
        current: {type: 1, alias: 'по группам'}
      },
      totalShifts: {},
      selectedUsers: [],
      groups: [],
    }
  },
  watch: {
    usersForSelect: {
      handler: function (val, oldVal) {
        this.users = val;
      },
      deep: true
    },
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = {...p}
        return acc
      }, {})
    },
  },
  created() {
    if (!this.usersForSelect) {
      this.getUsers();
    } else {
      this.users = [...this.usersForSelect];
    }
  },
  methods: {
    changeFilter(filter = null) {
      if (filter) this.filter.current = filter;
      let list = [];
      switch (this.filter.current.type) {
        case 1:
          const groups = [1, 2, 3, 7, 5, 4];
          groups.forEach((g) => {
            const group = this.groups.find((fg) => fg.group.id === g);
            const users = Object.values(group.users).reduce((acc, ug) => {
              acc = [...acc, ...ug.map((u) => u.id)]
              return acc;
            }, [])
            list = [...list, ...(this.users).filter((u) => users.includes(u.id))]
          })
          break;
        case 2:
          list = _.orderBy(this.users.map((u) => {
            return {...u, maxPause: this.totalDatByUserId(u.id)}
          }), 'maxPause', 'desc');
          break;
        case 3:
          list = _.orderBy(this.users.map((u) => {
            return {...u, maxPercent: this.totalDatByUserId(u.id, false)}
          }), 'maxPercent', 'desc');
          break;
      }
      this.selectedUsers = list;
    },
    selectGroup(id) {
      this.$refs.selectedGroup.selectedRecords = this.$refs.selectedGroup.records.filter((r) => r.id === id);
      const usersIds = this.groups.reduce((acc, g) => {
        if (g.group.id !== id) return acc;
        Object.values(g.users).forEach((us) => {
          acc = [...acc, ...(us ?? []).map((u) => u.id)]
        })
        return acc;
      }, []);
      this.$refs.selectedUsers.selectedRecords = this.$refs.selectedUsers.records.filter((r) => usersIds.includes(r.id));
    },
    getGroupsByUser(userId = null) {
      if (!userId) {
        return this.groups.reduce((acc, g) => {
          const projects = (g?.group?.data?.projects ?? []).reduce((acc1, p, i) => {
            acc1 += ((i !== 0 ? '+' : '') + this.$AllProjects[p]?.title);
            return acc1;
          }, ' ')
          acc.push({
            id: g.group.id,
            selectTitle: g.group.title + projects
          })
          return acc;
        }, []);
      }
      return this.groups.reduce((acc, g) => {
        const projects = (g?.group?.data?.projects ?? []).reduce((acc1, p, i) => {
          acc1 += ((i !== 0 ? '+' : '') + this.$AllProjects[p]?.title);
          return acc1;
        }, '');
        Object.values(g.users).forEach((ug) => {
          if (ug.find((user) => user.id === userId)) acc.push({...g.group, projects: projects});
        })
        return acc;
      }, [])
    },
    totalDatByUserId(userId, minutes = true) {
      const min = Object.values(this.records).reduce((acc, r) => {
        acc += (r[userId] ?? []).reduce((acc1, p) => acc1 += ((p.status && p.duration) ?? 0), 0);
        return acc;
      }, 0)
      return minutes ? min : Math.round(min * 100 / (this.totalShifts[userId]?.total_duration ?? 1));
    },
    getTotalDuration(records) {
      return records.reduce((acc, r) => acc += ((r.status && r.duration) ?? 0), 0);
    },
    hasRecords(id) {
      return Object.values(this.records ?? {}).find((r) => r[id]);
    },
    printDiff(record) {
      return +record.duration;
    },
    async getRecords(reset = false) {
      this.loading = true;
      if (reset) {
        this.$refs.selectedGroup.selectedRecords = [];
        this.$refs.selectedUsers.selectedRecords = [];
      }
      const range = this.$refs.range.dateRange;
      const selected = [...this.$refs.selectedUsers.selectedRecords];
      this.selectedUsers = (selected.length ? selected : [...(this.usersForSelect ?? this.users ?? [])]);
      const {data} = await api.post('/analytics/managers/activities/down/list', {
        dateRange: range,
        minPause: this.minPause,
        selectedGroups: this.$refs.selectedGroup.selectedRecords.map((r) => r.id),
        ids: this.selectedUsers.map((u) => u.id)
      })
      if (data.success) {
        this.groups = data.activeGroup;
        this.totalShifts = data.totalShifts.reduce((acc, s) => {
          acc[s.user_id] = s;
          return acc;
        }, {});
        this.records = data.records;
        this.changeFilter();
      }
      this.loading = false;
    },
    async getUsers() {
      const {data} = await api.post('/new/users/list', {
        roles: ['manager', 'managerAssist']
      });
      if (data.success) {
        this.users = data.records.map((u) => {
          return {...u, selectTitle: '(' + u.id + ') ' + u.name}
        });
      }
    }
  }
}

</script>


<style>
.activity_list_popover .popover_content {
  padding: 10px;
}

.activity_list_popover .popover_content p {
  margin-bottom: 2px;
}
</style>
<style scoped>
.flex_gap {
  gap: 10px;
}

.card {
  position: relative;
}

.table_div_block {
  overflow-x: scroll;
  overflow-y: visible;
  //width: 400px;
  //margin-left: 100px;
}

.table_div_block td,
.table_div_block th {
  width: 130px;
}

.table_div_block table {
  table-layout: fixed;
  width: 100%;
}

.def_width {
  width: 130px;
}

.fixed-side {
  position: absolute;
  width: 130px;
  background-color: white;
}

.table td, .table th {
  padding: 5px;
}

.form-group {
  margin-bottom: 0;
}

.action_btns {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.badge.badge-primary {
  font-size: 90%;
}
</style>
